(function() {
  'use strict';
  angular.module('dnSecurity')
  .factory('secLoginResource',['$resource', function($resource) {
    return $resource('/login');
  }])
  .factory('secLogoutResource',['$resource', function($resource) {
    return $resource('/logout');
  }])
  .factory('secPortalUserResource',['$resource', function($resource) {
    return $resource('/portalUser');
  }]);
})();
